module.exports = __webpack_public_path__ + "img/symbol_8.d8a4836c.png";